module.exports = __webpack_public_path__ + "static/media/step3.7d10580f.svg";